import React, { PureComponent } from "react";
import styled from "styled-components";
import { sigungu, dictSigungu} from "./vehicle_num.js";

import {
  BarChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Bar,
  ReferenceLine,
  LineChart,
  ComposedChart,
} from "recharts";

import {
  analyData,
  avgChartData,
  rankData,
  pData,
  vehicleAllData,
  vehicleSampleData
} from "./data.js";


export class LineGraph extends PureComponent {
  render() {
    return (
      <LineChart
        width={1150}
        height={500}
        data={pData}
        margin={{
          top: 5,
          right: 5,
          left: 0,
          bottom: 5,
        }}
      >
        <CartesianGrid vertical={true} strokeDasharray="3 3" />
        <XAxis dataKey="name" tickLine={false} tickSize="8" minTickGap="0" />
        <YAxis domain={[0, 400]} tickLine={false} tickSize="8" tickCount="9" />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="대"
          stroke="#EE6600"
          activeDot={{ r: 6 }}
        />
      </LineChart>
    );
  }
}


export class VehicleGraph extends PureComponent {
  render() {

    var gu = sessionStorage.getItem("sigungu");
    var local1 = dictSigungu[gu][0];
    var local2 = dictSigungu[gu][1];
    var local3 = dictSigungu[gu][2];
    var local4 = dictSigungu[gu][3];
    var localData = vehicleAllData.filter(({name})=>name===local1 || name===local2 || name===local3 || name===local4 );

    return (
      <ComposedChart width={1150} height={500} data={localData}>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <CartesianGrid stroke="#f5f5f5" />
        <Bar
          type="monotone"
          barSize={50}
          dataKey="관용"
          fill="#EF8A57"
          stackId="a"
        />
        <Bar
          type="monotone"
          barSize={50}
          dataKey="자가용"
          fill="#F9B787"
          stackId="a"
        />
        <Bar
          ype="monotone"
          dataKey="영업용"
          barSize={50}
          fill="#FCDF9A"
          stackId="a"
        />
        <Line type="monotone" dataKey="소계" stroke="#5779EF" />
      </ComposedChart>
    );
  }
}

export const GraphTitle = styled.div`
  position: relative;

  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: bold;
  font-size: ${(props) => props.fontSize || 24}px;
  line-height: 35px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: ${(props) => props.color || "#333333"};

  margin-bottom: ${(props) => props.marginBottom}px;
  margin-top: ${(props) => props.marginTop}px;
  margin-left: ${(props) => props.marginLeft}px;

  span {
    font-weight: normal;
    font-size: 17px;
  }
`;

export const GraphText = styled.div`
  position: relative;

  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: normal;
  font-size: ${(props) => props.fontSize || 17}px;
  line-height: ${(props) => props.lineHeigh || 25}px;

  margin-top: ${(props) => props.marginTop || 10}px;
  margin-bottom: ${(props) => props.marginBottom || 10}px;
  letter-spacing: ${(props) => props.letterSpacing || -0.01}em;

  color: ${(props) => props.color || "#555555"};
`;
